export default class miniManager {
    constructor() {

        //slider
        this.mySwiper;
        this.mySwiper2;

    }

    init() {

        setTimeout(function(){
            const mySwiper2 = this.mySwiper2 = new Swiper ('.slide02.swiper-container', {
                loop: true,
                initialSlide: 3,
            });
            const mySwiper = this.mySwiper = new Swiper ('.slide01.swiper-container', {
                loop: true,
                initialSlide: 3,
                navigation: {
                    nextEl: '.slide-control .next',
                    prevEl: '.slide-control .prev',
                },
            });
            let linkageFlag = true;
            let prevIndex = 3;
            let current = document.querySelector('.slide-number .current');
            let currentIndex;
            mySwiper.on('slideNextTransitionStart', function() {
                let index = this.realIndex;
                if(linkageFlag && index != prevIndex){
                    linkageFlag = false;
                    setTimeout(function(){
                        mySwiper2.slideNext();
                    },150)
                }
                prevIndex = index;
                linkageFlag = true;
                currentIndex = index+1;
                current.innerText = '0'+currentIndex;
            });
            mySwiper.on('slidePrevTransitionStart', function() {
                let index = this.realIndex;
                if(linkageFlag && index != prevIndex){
                    linkageFlag = false;
                    setTimeout(function(){
                        mySwiper2.slidePrev();
                    },150)
                }
                prevIndex = index;
                linkageFlag = true;
                currentIndex = index+1;
                current.innerText = '0'+currentIndex;
            });
            mySwiper2.on('slideNextTransitionStart', function() {
                let index = this.realIndex;
                if(linkageFlag && index != prevIndex){
                    linkageFlag = false;
                    setTimeout(function(){
                        mySwiper.slideNext();
                    },150)
                }
                prevIndex = index;
                linkageFlag = true;
            });
            mySwiper2.on('slidePrevTransitionStart', function() {
                let index = this.realIndex;
                if(linkageFlag && index != prevIndex){
                    linkageFlag = false;
                    setTimeout(function(){
                        mySwiper.slidePrev();
                    },150)
                }
                prevIndex = index;
                linkageFlag = true;
            });

        },200);

    }

    scroll() {

        if (this.mySwiper) {
            this.mySwiper.slideNext();
        }

    }

}

